/**
 * Fetch wrapper with timeout to prevent infinite hanging requests
 *
 * @param url - The URL to fetch
 * @param options - Standard fetch options
 * @param timeout - Timeout in milliseconds (default: 10000ms = 10s)
 * @returns Promise<Response>
 * @throws AbortError if timeout is reached
 */
export const fetchWithTimeout = (
    url: string,
    options: RequestInit = {},
    timeout: number = 20000
): Promise<Response> => {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), timeout);

    return fetch(url, {
        ...options,
        signal: controller.signal
    }).finally(() => {
        clearTimeout(timeoutId);
    });
};

